import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import { List, PictureAsPdf } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import {
    Button,
    ButtonGroup,
    Grid,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getDateStringYYYYMMDD } from 'app/utils/appHelpers';
import 'dayjs/locale/tr';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Autocomplete from '@mui/material/Autocomplete';
import LoadingPopUp from 'app/components/LoadingPopup';
import { getObjectListByPropertyApi } from 'api/general';
import { GATE_USER } from 'app/utils/constants/customConstant';
import { getUserByRoleIdAndInstApi } from 'api/user';

function ReportBoardMemberFilterCard({
    title,
    setFilterData,
    handleResultList: customHandleResultList,
    generatePDFApi: customGeneratePDFApi
}) {
    const defaultStartDate = new Date();
    defaultStartDate.setDate(1);
    defaultStartDate.setMonth(0);
    const defaultFinishedDate = new Date();
    const authUser = useSelector(state => state.auth.authUser);

    const [state, setState] = useState({
        selectedUser: null,
        attendanceStatus: '',
        startedDate: defaultStartDate,
        finishedDate: defaultFinishedDate,
    });
    const [loading, setLoading] = useState(false);
    const [lastFilter, setLastFilter] = useState(null);
    const [userList, setUserList] = useState([]);

    useEffect(() => {
        const fetchBoardMembers = async () => {
            try {
                const response = await getUserByRoleIdAndInstApi(100, "all");
                const data = await response.data;
                setUserList(data);
            } catch (error) {
                console.error('Error fetching board members:', error);
            }
        };
        fetchBoardMembers();
    }, []);

    const isUserSelected = !!state.selectedUser;
    const hasDataToClear = isUserSelected || state.attendanceStatus ||
        state.startedDate !== defaultStartDate ||
        state.finishedDate !== defaultFinishedDate;

    const handleResultListClick = async () => {
        const newStartDate = getDateStringYYYYMMDD(state.startedDate, "00:00:01");
        const newFinishedDate = getDateStringYYYYMMDD(state.finishedDate, "23:59:59");

        const filters = {
            userId: state.selectedUser?.id || null,
            startedDate: newStartDate,
            finishedDate: newFinishedDate
        };

        setLoading(true);
        try {
            await customHandleResultList(filters);
            setLastFilter(filters);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleGeneratePDF = async () => {
        if (!lastFilter) return;
        setLoading(true);
        try {
            await customGeneratePDFApi();
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleClear = () => {
        setState({
            selectedUser: null,
            startedDate: defaultStartDate,
            finishedDate: defaultFinishedDate,
        });
        setLastFilter(null);
        setFilterData([]);
    };

    return (
        <>
            <LoadingPopUp open={loading} />
            {!loading && (
                <JumboCardQuick title={title}>
                    <Grid container spacing={1} mb={1}>
                        <Grid item xs={3}>
                            <Autocomplete
                                size="small"
                                id="user-autocomplete"
                                options={userList}
                                value={state.selectedUser}
                                onChange={(event, newValue) => {
                                    setState(prevState => ({ ...prevState, selectedUser: newValue }));
                                }}
                                getOptionLabel={(option) => `${option.title || ''} ${option.name || ''} ${option.surname || ''}`.trim()}
                                renderInput={(params) => (
                                    <TextField {...params} label="Üye" variant="outlined" size="small" />
                                )}
                            />
                        </Grid>



                        {/* Tarih Seçimleri */}
                        <Grid item xs={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">
                                <DatePicker
                                    label="Başlangıç"
                                    size="small"
                                    value={state.startedDate}
                                    onChange={(newValue) =>
                                        setState(prevState => ({ ...prevState, startedDate: newValue }))
                                    }
                                    renderInput={(params) => <TextField {...params} size="small" />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">
                                <DatePicker
                                    label="Bitiş"
                                    size="small"
                                    value={state.finishedDate}
                                    onChange={(newValue) =>
                                        setState(prevState => ({ ...prevState, finishedDate: newValue }))
                                    }
                                    renderInput={(params) => <TextField {...params} size="small" />}
                                />
                            </LocalizationProvider>
                        </Grid>

                        {/* İşlem Butonları */}
                        <Grid item xs={2}>
                            <ButtonGroup>
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    color="success"
                                    startIcon={<List />}
                                    onClick={handleResultListClick}
                                    disabled={!isUserSelected}
                                >
                                    Listele
                                </Button>
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    color="success"
                                    startIcon={<PictureAsPdf />}
                                    disabled={!lastFilter || !isUserSelected}
                                    onClick={handleGeneratePDF}
                                >
                                    PDF
                                </Button>
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    color="success"
                                    startIcon={<DeleteIcon />}
                                    onClick={handleClear}
                                    disabled={!hasDataToClear}
                                >
                                    TEMİZLE
                                </Button>
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                </JumboCardQuick>
            )}
        </>
    );
}

export default ReportBoardMemberFilterCard; 